import React, { useState } from "react";
import print from "../../images/icons/print2.svg";
import printActive from "../../images/icons/print2-active.svg";
import { appendToken } from "../utils";

const PrintButton = ({ printPreviewUrl, publicPortal, toggleLoginModal }) => {
  const [iconHover, setIconHover] = useState(false);

  return (
    <button
      type="button"
      className=""
      data-dismiss="modal"
      aria-label="print"
      onClick={() =>
        publicPortal
          ? toggleLoginModal()
          : window.open(
            appendToken(printPreviewUrl),
            "Print Preview",
            'rel="noopener"'
          )
      }
      onMouseEnter={() => setIconHover(true)}
      onMouseLeave={() => setIconHover(false)}
    >
      <img
        src={iconHover ? printActive : print}
        className="no_background"
        alt="print"
      />
    </button>
  );
};

export default PrintButton;
